import {Injectable} from '@angular/core';
import {Observable} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {environment} from "../../../../environments/environment";
import {VehicleDto} from "../../../auto-generated-server-dtos/warranty-search/vehicle-dto";

@Injectable({
  providedIn: 'root'
})
export class VinSearchService {

  constructor(private httpClient: HttpClient) {
  }

  VinSearch(vin: string): Observable<VehicleDto[]> {
    return this.httpClient.get<VehicleDto[]>(`${environment.apiServer}/VinSearch`, {params: {vin: vin}});
  }
}
